/* eslint-disable eqeqeq */
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { config } from "_helpers/config";
import _ from "lodash";
import { docsActions } from "_actions/docs.actions";
import { toast } from "react-toastify";
import { FormNav } from "./FormNav";
import { navigate, validate } from "./formHandlers";
import moment from "moment";
import PropTypes from "prop-types";
import { getCurrentUserInfo } from "_helpers/reduxSelector";
import checkIfDocsShouldBeLocked from "_helpers/lockDocs";
import { documentTypes } from "_constants";
import { autoPopulateSignature } from "../../_helpers/signatureAutoPopulate";
import {
  DEFAULT_STATE_TAX_UI_TYPE,
  getStateTaxTypeFromResourceCrewTypeAndForm,
  OREGON_UI_TYPES,
  STATE_TAX_UI_CONFIG,
  STATE_TAX_UI_TYPES,
} from "./StateTax/constants";
import StateTaxRedmondView from "./StateTax/StateTaxRedmondView";
import StateTaxSpringfieldView from "./StateTax/StateTaxSpringfieldView";
import StateTaxEllensburgView from "./StateTax/StateTaxEllensburgView";
import StateTaxBoiseView from "./StateTax/StateTaxBoiseView";
import StateTaxAshevilleView from "./StateTax/StateTaxAshevilleView";
import { nc4Sched2ChildrenDefaultFields } from "./StateTax/StateTaxNc4Schedule2";
import { computeBoiseWorksheetItemizedLineFields } from "./StateTax/boiseWorksheetItemizedLines";

class StateTax extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rehire_doc: false,
      doc: {},
      resource_crew_type: null,
      sign: { height: 144, width: 446 },
      form: {
        employee_printed_name: "",
        employee_signature: null,
        signed_date: moment().format("MM/DD/YYYY"),
        disclaimer_check: false,
        // Oregon W-4 style fields (OR-W-4)
        first_name: "",
        middle_initial: "",
        last_name: "",
        ssn: "",
        redetermination: false,
        address: "",
        city: "",
        state: "",
        zip_code: "",
        filing_status_single: false,
        filing_status_married: false,
        filing_status_married_single_rate: false,
        filing_status_married_separate: false,
        filing_status_head_of_household: false,
        address_country: "",
        allowances: "",
        additional_amount: "",
        /** Idaho Line 2 worksheet (page 2) — optional; persisted with form JSON */
        boise_worksheet_other_jobs: "",
        boise_worksheet_other_income: "",
        boise_worksheet_itemized_line4: "",
        boise_worksheet_pay_periods: "",
        boise_worksheet_itemized_line_1: "",
        boise_worksheet_itemized_line_2: "",
        boise_worksheet_itemized_line_3: "",
        boise_worksheet_itemized_line_4: "",
        boise_worksheet_itemized_line_5: "",
        boise_worksheet_itemized_line_6: "",
        boise_worksheet_itemized_line_7: "",
        boise_worksheet_itemized_line_8: "",
        boise_worksheet_itemized_line_9: "",
        exemption_code_4a: "",
        exempt_4b: "",
        employer_name: "",
        fein: "",
        employer_address: "",
        employer_city: "",
        employer_state: "",
        employer_zip: "",
        /** NC-4 Part I worksheet (page 3) — yes/no per question */
        nc4_worksheet_single_1: "",
        nc4_worksheet_single_2: "",
        nc4_worksheet_single_3: "",
        nc4_worksheet_single_4: "",
        nc4_worksheet_mfj_1: "",
        nc4_worksheet_mfj_2: "",
        nc4_worksheet_mfj_3: "",
        nc4_worksheet_mfj_4: "",
        nc4_worksheet_mfj_5: "",
        nc4_worksheet_mfs_1: "",
        nc4_worksheet_mfs_2: "",
        nc4_worksheet_mfs_3: "",
        nc4_worksheet_mfs_4: "",
        nc4_worksheet_hoh_1: "",
        nc4_worksheet_hoh_2: "",
        nc4_worksheet_hoh_3: "",
        nc4_worksheet_hoh_4: "",
        nc4_worksheet_ss_1: "",
        nc4_worksheet_ss_2: "",
        nc4_worksheet_ss_3: "",
        nc4_worksheet_ss_4: "",
        /** NC-4 Part II (page 4) — withholding allowance worksheet */
        nc4_part2_line1: "",
        nc4_part2_line4: "",
        nc4_part2_line5: "",
        nc4_part2_line7: "",
        nc4_part2_line8: "",
        nc4_part2_line12: "",
        nc4_part2_line14: "",
        nc4_part2_line16: "",
        nc4_schedule1_skip: false,
        nc4_sched1_home_mortgage: "",
        nc4_sched1_real_estate_taxes: "",
        nc4_sched1_charitable: "",
        nc4_sched1_medical: "",
        nc4_sched1_repayment_claim: "",
        nc4_schedule2_skip: false,
        ...nc4Sched2ChildrenDefaultFields(),
      },
      errors: {},
      form_edited: false,
      /** Idaho Form ID W-4: page 1 = instructions + certificate + signature; page 2 = worksheets. */
      idahoPage: 1,
      /** NC Form NC-4: p1–p2 cert; p3 Part I; p4 Part II; p5 Sched 1; p6 Sched 2. */
      ncPage: 1,
      /** Ellensburg WA: user must open the read-document link before submit (see FormNav). */
      readEllensburgHandbook: false,
    };

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSignature = this.handleSignature.bind(this);
    this.handleSsnChange = this.handleSsnChange.bind(this);
    this.validate = validate.bind(this);
    this.validateNcCertificate = this.validateNcCertificate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.navigate = navigate.bind(this);
    this.handleStateTaxMultiPageNavigate =
      this.handleStateTaxMultiPageNavigate.bind(this);
    this.handleSchedule1Skip = this.handleSchedule1Skip.bind(this);
    this.goBack = this.goBack.bind(this);
    this.form = React.createRef();
    this.signContainer = React.createRef();
  }

  handleFormChange(e) {
    const target = e.target;
    const field = target?.getAttribute?.("field");
    if (!field) {
      return;
    }
    const { value, checked, type } = target;
    const nextVal = type === "checkbox" ? checked : value;

    if (field.startsWith("form.")) {
      const formKey = field.slice(5);
      this.setState((prev) => {
        const nextForm = { ...prev.form, [formKey]: nextVal };
        const stateTaxType = getStateTaxTypeFromResourceCrewTypeAndForm(
          prev.resource_crew_type,
          nextForm,
        );
        const withBoiseLines =
          stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID
            ? {
                ...nextForm,
                ...computeBoiseWorksheetItemizedLineFields(nextForm),
              }
            : nextForm;
        return {
          ...prev,
          form: withBoiseLines,
          errors: { ...prev.errors, [field]: "" },
          form_edited: true,
        };
      });
      return;
    }

    const nextState = _.cloneDeep(this.state);
    _.set(nextState, field, nextVal);
    this.setState({
      ...nextState,
      errors: { ...this.state.errors, [field]: "" },
      form_edited: true,
    });
  }

  handleSignature(field, signature) {
    if (field?.startsWith?.("form.")) {
      const formKey = field.slice(5);
      this.setState((prev) => ({
        ...prev,
        form: { ...prev.form, [formKey]: signature },
        form_edited: true,
      }));
      return;
    }
    const nextState = _.cloneDeep(this.state);
    _.set(nextState, field, signature);
    this.setState({ ...nextState, form_edited: true });
  }

  handleDateChange(field, date) {
    if (!date) {
      return;
    }
    const formatted = date.format("MM/DD/YYYY");
    if (field?.startsWith?.("form.")) {
      const formKey = field.slice(5);
      this.setState((prev) => ({
        ...prev,
        form: { ...prev.form, [formKey]: formatted },
        errors: { ...prev.errors, [field]: "" },
        form_edited: true,
      }));
      return;
    }
    const nextState = _.cloneDeep(this.state);
    _.set(nextState, field, formatted);
    this.setState({
      ...nextState,
      errors: { ...this.state.errors, [field]: "" },
      form_edited: true,
    });
  }

  handleStateTaxMultiPageNavigate(to, rehire, giss) {
    const stateTaxType = getStateTaxTypeFromResourceCrewTypeAndForm(
      this.state.resource_crew_type,
      this.state.form,
    );
    if (
      stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID &&
      to === "prev" &&
      this.state.idahoPage > 1
    ) {
      this.setState({ idahoPage: this.state.idahoPage - 1 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (
      stateTaxType === STATE_TAX_UI_TYPES.ASHEVILLE_NC &&
      to === "prev" &&
      this.state.ncPage > 1
    ) {
      this.setState({ ncPage: this.state.ncPage - 1 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    navigate.call(this, to, rehire, giss, this);
  }

  /** Schedule 1 (page 5): skip as zero and go to Schedule 2. */
  handleSchedule1Skip() {
    this.setState((prev) => ({
      ncPage: 6,
      form_edited: true,
      form: {
        ...prev.form,
        nc4_schedule1_skip: true,
        nc4_sched1_home_mortgage: "",
        nc4_sched1_real_estate_taxes: "",
        nc4_sched1_charitable: "",
        nc4_sched1_medical: "",
        nc4_sched1_repayment_claim: "",
      },
    }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /**
   * NC final page submit: certificate fields are unmounted, so validate from state.
   */
  validateNcCertificate() {
    const { form } = this.state;
    const errors = { ...this.state.errors };
    let err = false;
    const setErr = (key, msg) => {
      errors[key] = msg;
      err = true;
    };
    if (!String(form.first_name || "").trim()) {
      setErr("form.first_name", "This field is required.");
    }
    if (!String(form.last_name || "").trim()) {
      setErr("form.last_name", "This field is required.");
    }
    const ssnDigits = String(form.ssn || "").replace(/\D/g, "");
    if (ssnDigits.length !== 9) {
      setErr("form.ssn", "Please enter a valid SSN.");
    }
    if (!form.employee_signature) {
      setErr("form.employee_signature", "This field is required.");
    }
    if (!form.disclaimer_check) {
      setErr("form.disclaimer_check", "Please agree to continue");
    }
    this.setState({ errors });
    return err;
  }

  submitForm(e) {
    e.preventDefault();

    let { form, doc, resource_crew_type } = this.state;
    const stateTaxType = getStateTaxTypeFromResourceCrewTypeAndForm(
      resource_crew_type,
      form,
    );
    const isBoise = stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID;
    const isNc = stateTaxType === STATE_TAX_UI_TYPES.ASHEVILLE_NC;

    if (isBoise && this.state.idahoPage < 2) {
      const err = this.validate();
      if (err) return;
      this.setState({ idahoPage: 2 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        if (this.signContainer && this.signContainer.clientWidth) {
          this.setState({
            sign: {
              height: this.signContainer.clientHeight || 144,
              width: this.signContainer.clientWidth || 446,
            },
          });
        }
      }, 150);
      return;
    }

    if (isNc && this.state.ncPage === 1) {
      this.setState({ ncPage: 2 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        if (this.signContainer && this.signContainer.clientWidth) {
          this.setState({
            sign: {
              height: this.signContainer.clientHeight || 144,
              width: this.signContainer.clientWidth || 446,
            },
          });
        }
      }, 150);
      return;
    }

    if (isNc && this.state.ncPage === 2) {
      const page2Err = this.validate();
      if (page2Err) return;
      this.setState({ ncPage: 3 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (isNc && this.state.ncPage === 3) {
      this.setState({ ncPage: 4 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (isNc && this.state.ncPage === 4) {
      this.setState({ ncPage: 5 });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (isNc && this.state.ncPage === 5) {
      this.setState((prev) => ({
        ncPage: 6,
        form: {
          ...prev.form,
          nc4_schedule1_skip: false,
        },
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    let err =
      isNc && this.state.ncPage === 6
        ? this.validateNcCertificate()
        : this.validate();
    if (err) return;

    const useOregonForm = OREGON_UI_TYPES.includes(stateTaxType);
    const useIdahoForm = stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID;
    const useNcForm = stateTaxType === STATE_TAX_UI_TYPES.ASHEVILLE_NC;
    if (
      (useOregonForm || useIdahoForm || useNcForm) &&
      (form.first_name || form.last_name)
    ) {
      form = {
        ...form,
        employee_printed_name: [form.first_name, form.last_name]
          .filter(Boolean)
          .join(" "),
      };
    }
    if (useIdahoForm) {
      form = {
        ...form,
        ...computeBoiseWorksheetItemizedLineFields(form),
      };
    }
    let data = {
      id: doc.id,
      doc_type: doc.docs_type_id,
      form: {
        ...form,
        /** Persisted for PDF: must match the variant the employee actually completed (see ApiDocsController). */
        state_tax_ui_type: stateTaxType,
        signed_date: moment(form.signed_date).isValid()
          ? moment(form.signed_date).format("MM/DD/YYYY")
          : form.signed_date,
      },
    };

    if (this.props.adminMode) data.admin_mode = this.props.adminMode;
    this.props.single_doc ? (data.single_doc = true) : (data.single_doc = false);
    this.props.rehire ? (data.rehire = true) : (data.rehire = false);

    this.props.dispatch(docsActions.saveDoc(data)).then((res) => {
      if (res.success) {
        if (this.props.mobileMode && !this.props.lastPage) {
          this.props.setScreen("sidebar");
          this.navigate("next", this.props.rehire);
        } else if (this.props.lastPage) {
          if (this.props.adminMode) {
            this.props.history.push(`/docs`);
          } else {
            this.props.history.push(`/dashboard`);
          }
        } else {
          this.navigate("next", this.props.rehire);
        }
      } else {
        if (this.props.mobileMode) this.props.toggleErrorPopup(res.message);
        else toast.error(res.message);
      }
    });
  }

  getFormData(id) {
    this.props.dispatch(docsActions.getForm(id)).then((res) => {
      if (res.success) {
        const currentState = this.state;
        let { form, user, resource_crew_type } = res.data;
        form.signed_date = form.signed_date || currentState.form.signed_date;
        if (!form?.employee_printed_name && user?.full_name) {
          form.employee_printed_name = user.full_name;
        }
        // OR-W-4 (Oregon): prefill legal name from employee profile when not stored on the doc
        if (!form?.first_name && user?.first_name) {
          form.first_name = user.first_name;
        }
        if (!form?.last_name && user?.last_name) {
          form.last_name = user.last_name;
        }
        if (!form?.middle_initial && user?.middle_name) {
          const mi = String(user.middle_name).replace(/\./g, "").trim();
          form.middle_initial = mi.slice(0, 2);
        }
        const formSsnDigits = String(form?.ssn || "").replace(/\D/g, "");
        if (formSsnDigits.length !== 9 && user?.ssn) {
          form.ssn = this.formatSsn(String(user.ssn));
        }
        const mergedForm = { ...currentState.form, ...form };
        const stateTaxType = getStateTaxTypeFromResourceCrewTypeAndForm(
          resource_crew_type ?? null,
          mergedForm,
        );
        const finalForm =
          stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID
            ? {
                ...mergedForm,
                ...computeBoiseWorksheetItemizedLineFields(mergedForm),
              }
            : mergedForm;
        this.setState(
          { form: finalForm, resource_crew_type: resource_crew_type ?? null },
          () => {
            setTimeout(() => {
              autoPopulateSignature(
                this.state.form,
                (signature) => {
                  this.handleSignature("form.employee_signature", signature);
                },
                "employee_signature",
              );
            }, 100);
          },
        );
      }
    });
  }

  goBack() {
    if (this.state.form_edited) {
      this.props.toggleCloseConfirmation(true);
    } else {
      this.props.setScreen("sidebar");
    }
  }

  componentDidMount() {
    let docSlug = this.props.slug
      ? this.props.slug
      : this.props.match.params.doc;

    const allowedCategories = this.props.rehire
      ? [documentTypes.Rehire, documentTypes.GISS_Rehire]
      : this.props.single_doc
        ? [documentTypes.Other]
        : [documentTypes.Onboarding, documentTypes.GISS_Onboarding];

    const doc = this.props.docs.userDocs.find(
      (d) => d.slug === docSlug && allowedCategories.includes(d.docs_categories_id),
    );

    this.setState({ doc });
    if (doc?.id) this.getFormData(doc.id);

    // Measure sign pad container so SignPad can render (same as W4)
    const setSignFromContainer = () => {
      if (this.signContainer && this.signContainer.clientWidth) {
        this.setState({
          sign: {
            height: this.signContainer.clientHeight || 144,
            width: this.signContainer.clientWidth || 446,
          },
        });
      }
    };
    setSignFromContainer();
    // Retry after form/layout in case container isn't ready yet
    setTimeout(setSignFromContainer, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    // When switching to Oregon form or after getFormData, ensure sign dimensions are set
    if (!this.state.sign && this.signContainer && this.signContainer.clientWidth) {
      this.setState({
        sign: {
          height: this.signContainer.clientHeight || 144,
          width: this.signContainer.clientWidth || 446,
        },
      });
    }
  }

  render() {
    let { form, errors, resource_crew_type } = this.state;
    let { adminMode, currentUserInfo } = this.props;

    const shouldLockDocs = checkIfDocsShouldBeLocked(
      currentUserInfo,
      form,
      adminMode,
    );

    // Resolve UI variant from crew location; if missing/wrong (defaults to OR), infer Boise from saved form fields.
    const stateTaxType = getStateTaxTypeFromResourceCrewTypeAndForm(
      resource_crew_type,
      form,
    );
    const uiConfig =
      STATE_TAX_UI_CONFIG[stateTaxType] ||
      STATE_TAX_UI_CONFIG[DEFAULT_STATE_TAX_UI_TYPE];
    const variantClass = uiConfig.variantClass || "";
    const useOregonForm = OREGON_UI_TYPES.includes(stateTaxType);
    const useStructuredStateTaxForm =
      useOregonForm ||
      stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID ||
      stateTaxType === STATE_TAX_UI_TYPES.ASHEVILLE_NC;
    const useMpnHandbookLayout =
      stateTaxType === STATE_TAX_UI_TYPES.ELLENSBURG_WA;
    const stateTaxViewComponents = {
      [STATE_TAX_UI_TYPES.REDMOND_OR]: StateTaxRedmondView,
      [STATE_TAX_UI_TYPES.SPRINGFIELD_OR]: StateTaxSpringfieldView,
      [STATE_TAX_UI_TYPES.ELLENSBURG_WA]: StateTaxEllensburgView,
      [STATE_TAX_UI_TYPES.BOISE_ID]: StateTaxBoiseView,
      [STATE_TAX_UI_TYPES.ASHEVILLE_NC]: StateTaxAshevilleView,
    };
    const ActiveStateTaxView =
      stateTaxViewComponents[stateTaxType] || StateTaxRedmondView;
    const isBoiseMulti = stateTaxType === STATE_TAX_UI_TYPES.BOISE_ID;
    const isNcMulti = stateTaxType === STATE_TAX_UI_TYPES.ASHEVILLE_NC;
    const isStateTaxMultiPage = isBoiseMulti || isNcMulti;
    const formNavPage = isBoiseMulti
      ? this.state.idahoPage
      : isNcMulti
        ? this.state.ncPage
        : 1;
    const formNavPages = isBoiseMulti ? 2 : isNcMulti ? 6 : 1;
    // FormNav: "Submit Documents" only when this doc is last in the queue AND
    // (multi-page) user is on the final sheet. Otherwise last sheet still shows "Next".
    const formNavLastPage = isBoiseMulti
      ? this.state.idahoPage === 2 && this.props.lastPage
      : isNcMulti
        ? this.state.ncPage === 6 && this.props.lastPage
        : this.props.lastPage;

    const isEllensburgWa = stateTaxType === STATE_TAX_UI_TYPES.ELLENSBURG_WA;
    const disclaimerForFormNav = isBoiseMulti
      ? true
      : isNcMulti
        ? this.state.ncPage === 6
          ? !!form.disclaimer_check
          : true
        : isEllensburgWa
          ? !!form.disclaimer_check && this.state.readEllensburgHandbook
          : !!form.disclaimer_check;

    const stateTaxFormForView = isBoiseMulti
      ? { ...form, ...computeBoiseWorksheetItemizedLineFields(form) }
      : form;

    return (
      <div className={`doc_info-rh form-w4 state-tax-form ${variantClass}`}>
        <div className="doc-title">
          <img
            src={`${config.assetUrl}icons/doc-title-img.svg`}
            className="doc-title-img"
            alt=""
          />
          <span className="close-button" onClick={this.goBack}>
            <img src={`${config.assetUrl}icons/back-btn.svg`} alt="Back" />
          </span>
          <h3>{uiConfig.title}</h3>
          {isStateTaxMultiPage && (
            <div
              className={
                this.props.single_doc
                  ? "doc-page-count left_non_auto"
                  : "doc-page-count"
              }
            >
              <span className="current_page">{formNavPage}</span>
              <span>of {formNavPages}</span>
            </div>
          )}
        </div>

        {isStateTaxMultiPage && (
          <div className="custom-pagination-nav">
            <div className="pagination-wrapper">
              {formNavPage > 1 && (
                <button
                  type="button"
                  className="previous"
                  onClick={() =>
                    this.handleStateTaxMultiPageNavigate("prev")
                  }
                >
                  <svg
                    width="6"
                    height="11"
                    viewBox="0 0 6 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.41406 10.6094L5.88281 10.1641C5.97656 10.0469 5.97656 9.85938 5.88281 9.76562L1.64062 5.5L5.88281 1.25781C5.97656 1.16406 5.97656 0.976562 5.88281 0.859375L5.41406 0.414062C5.29688 0.296875 5.13281 0.296875 5.01562 0.414062L0.09375 5.3125C0 5.42969 0 5.59375 0.09375 5.71094L5.01562 10.6094C5.13281 10.7266 5.29688 10.7266 5.41406 10.6094Z"
                      fill="black"
                      fillOpacity="0.87"
                    />
                  </svg>
                </button>
              )}
              <p>
                Page {formNavPage} <span>of {formNavPages}</span>
              </p>
              {formNavPage < formNavPages && (
                <button
                  type="button"
                  className="next"
                  onClick={() =>
                    this.submitForm({ preventDefault: () => {} })
                  }
                >
                  <svg
                    width="6"
                    height="11"
                    viewBox="0 0 6 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.5625 0.414062L0.09375 0.859375C0 0.976562 0 1.16406 0.09375 1.25781L4.33594 5.5L0.09375 9.76562C0 9.85938 0 10.0469 0.09375 10.1641L0.5625 10.6094C0.679688 10.7266 0.84375 10.7266 0.960938 10.6094L5.88281 5.71094C5.97656 5.59375 5.97656 5.42969 5.88281 5.3125L0.960938 0.414062C0.84375 0.296875 0.679688 0.296875 0.5625 0.414062Z"
                      fill="black"
                      fillOpacity="0.8"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        )}

        <div className="doc_info-form">
          <form
            className={`info-form ${useStructuredStateTaxForm ? "state-tax-form-oregon" : ""} ${useMpnHandbookLayout ? "mpn" : ""}`}
            ref={this.form}
            onChange={this.handleFormChange}
            onSubmit={this.submitForm}
            noValidate
          >
            <fieldset disabled={shouldLockDocs}>
              <ActiveStateTaxView
                form={stateTaxFormForView}
                errors={errors}
                uiConfig={uiConfig}
                page={formNavPage}
                sign={this.state.sign}
                onReadDocumentClick={
                  isEllensburgWa
                    ? () => this.setState({ readEllensburgHandbook: true })
                    : undefined
                }
                onFormChange={this.handleFormChange}
                onDateChange={(fieldOrDate, maybeDate) => {
                  if (maybeDate) {
                    this.handleDateChange(fieldOrDate, maybeDate);
                    return;
                  }
                  const date = fieldOrDate;
                  this.setState({
                    form: {
                      ...this.state.form,
                      signed_date: moment(date).format("MM/DD/YYYY"),
                    },
                    form_edited: true,
                  });
                }}
                onSignature={(signature) =>
                  this.handleSignature("form.employee_signature", signature)
                }
                onSsnChange={this.handleSsnChange}
                setSignContainer={(el) => {
                  this.signContainer = el;
                }}
                onSchedule1Skip={this.handleSchedule1Skip}
              />
            </fieldset>
            <FormNav
              {...this.props}
              submitForm={this.submitForm}
              navigate={
                isStateTaxMultiPage
                  ? this.handleStateTaxMultiPageNavigate
                  : this.navigate
              }
              currentPage={formNavPage}
              noOfPages={formNavPages}
              disclaimer_check={disclaimerForFormNav}
              lastPage={formNavLastPage}
              skip={false}
              skipHandler={() => {}}
            />
          </form>
        </div>
      </div>
    );
  }

  formatSsn(value) {
    const digits = (value || "").replace(/\D/g, "").slice(0, 9);
    if (digits.length <= 3) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }

  handleSsnChange(e) {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 9);
    const formatted = this.formatSsn(raw);
    this.setState({
      form: { ...this.state.form, ssn: formatted },
      form_edited: true,
    });
  }

}

StateTax.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  docs: PropTypes.object.isRequired,
  rehire: PropTypes.bool,
  giss: PropTypes.bool,
  adminMode: PropTypes.bool,
  lastPage: PropTypes.bool,
  mobileMode: PropTypes.bool,
  setScreen: PropTypes.func,
  toggleCloseConfirmation: PropTypes.func,
  toggleErrorPopup: PropTypes.func,
  single_doc: PropTypes.bool,
  slug: PropTypes.string,
  currentUserInfo: PropTypes.object,
};

StateTax.defaultProps = {
  rehire: false,
  giss: false,
  adminMode: false,
  lastPage: false,
  mobileMode: false,
  single_doc: false,
};

const mapStateToProps = (state) => ({
  docs: state.docs,
  currentUserInfo: getCurrentUserInfo(state),
});

let connectedStateTax = compose(
  withRouter,
  connect(mapStateToProps),
)(StateTax);

export { connectedStateTax as StateTax };
